import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49acc990"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col max-w-[40rem] mx-auto bg-white text-primary-black" }
const _hoisted_2 = { class: "w-full flex flex-col p-5" }
const _hoisted_3 = { class: "w-full pt-3" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex flex-col justify-center gap-10 mt-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-black text-3xl leading-8" }, [
  /*#__PURE__*/_createTextVNode(" Become a place "),
  /*#__PURE__*/_createElementVNode("span", { class: "block text-primary-violet" }, "people want"),
  /*#__PURE__*/_createElementVNode("span", { class: "block" }, "to work for")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg leading-7 -mt-5" }, " Partner with Workbean to help you in your employer branding and culture championing initiatives. Let’s make your talent acquisition experience better - together! ", -1))
const _hoisted_8 = {
  href: "https://share.hsforms.com/16L5jPV9wTKm7A5nG7cF_tA49jl2",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_9 = { class: "flex flex-col mt-5 bg-[#F6F6F6] py-5" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold text-[#9C9C9C] text-center mx-auto" }, "Trusted by some of the best places to work", -1))
const _hoisted_11 = { class: "flex gap-9 items-center overflow-auto pt-4 scroll" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "w-full flex flex-col p-5" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col justify-center gap-10 mt-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-black text-3xl leading-10 text-end" }, [
    /*#__PURE__*/_createTextVNode(" Join the only "),
    /*#__PURE__*/_createElementVNode("h2", null, [
      /*#__PURE__*/_createElementVNode("span", { class: "text-primary-violet" }, "culture-first"),
      /*#__PURE__*/_createTextVNode(" job ")
    ]),
    /*#__PURE__*/_createTextVNode(" platform in Asia ")
  ]),
  /*#__PURE__*/_createElementVNode("h2", { class: "text-lg leading-7 -mt-5 text-end" }, " Your culture will always be put front and center to attract the right people for your company. No other job board can articulate your culture better than we can. Trust us! ")
], -1))
const _hoisted_16 = { class: "w-full my-5" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "flex flex-col gap-10 mt-5" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-black text-3xl leading-10" }, [
  /*#__PURE__*/_createTextVNode(" Amplify your "),
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-primary-violet" }, "Employees' voices"),
    /*#__PURE__*/_createTextVNode(" and ")
  ]),
  /*#__PURE__*/_createTextVNode(" share it to the world. ")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg leading-7 -mt-5 text" }, "Unlock the power of employee ambassadorship from your Workbean dashboard. Never worry about another employer branding content again!", -1))
const _hoisted_21 = {
  href: "https://share.hsforms.com/16L5jPV9wTKm7A5nG7cF_tA49jl2",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_22 = { class: "w-full flex justify-center" }
const _hoisted_23 = { class: "w-fit" }
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-10 mt-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-black text-3xl leading-10 text-end" }, [
    /*#__PURE__*/_createTextVNode(" Measure your success "),
    /*#__PURE__*/_createElementVNode("span", { class: "block" }, "with the first-ever"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-primary-violet block" }, "Employer Brand"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-primary-violet block" }, "Health Score.")
  ]),
  /*#__PURE__*/_createElementVNode("h2", { class: "text-lg leading-7 -mt-5 text-end" }, " Articulate the value of your efforts, quantify and benchmark your employer brand with our health scoring sytem. Leave the guesswork and prove that employer branding works! ")
], -1))
const _hoisted_26 = { class: "w-full flex justify-center" }
const _hoisted_27 = { class: "w-fit" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "w-full flex flex-row-reverse pt-5" }
const _hoisted_30 = {
  href: "https://share.hsforms.com/16L5jPV9wTKm7A5nG7cF_tA49jl2",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_31 = { class: "bg-[#F1EEFF] flex flex-col gap-5 p-7" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-black text-3xl leading-10" }, "Deep dive with Workbean Consulting Services", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-light-gray-200" }, [
  /*#__PURE__*/_createTextVNode(" Partner with us to take an in-depth review of your employer branding strategy. We will help you unlock your company’s true employee value proposition (EVP) using our proprietary "),
  /*#__PURE__*/_createElementVNode("span", { class: "underline" }, "Employer Branding Matrix.")
], -1))
const _hoisted_34 = { class: "w-full flex justify-center pb-5" }
const _hoisted_35 = { class: "w-fit" }
const _hoisted_36 = ["src"]
const _hoisted_37 = {
  href: "https://share.hsforms.com/16L5jPV9wTKm7A5nG7cF_tA49jl2",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_38 = { class: "flex flex-col p-5 gap-5" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-black text-3xl leading-10" }, "We’re certified Employer Brand Leaders so you can trust us to do the job.", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-light-gray-200" }, " The Certificate in Employer Brand Leadership is the world's first globally recognized qualification and accreditation for Employer Brand Leadership. ", -1))
const _hoisted_41 = { class: "w-full flex justify-center" }
const _hoisted_42 = { class: "w-fit" }
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "flex flex-col mt-5 bg-[#F6F6F6] py-5" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold text-[#9C9C9C] text-center mx-auto" }, "As seen on", -1))
const _hoisted_46 = { class: "flex gap-5 items-center overflow-auto pt-4 scroll" }
const _hoisted_47 = ["src", "alt"]
const _hoisted_48 = { class: "w-full bg-light-gray-100" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-black text-3xl text-center pt-5" }, "Join the movement", -1))
const _hoisted_50 = { class: "flex flex-col justify-center items-center p-10 gap-5" }
const _hoisted_51 = { class: "w-fit" }
const _hoisted_52 = ["src", "alt"]
const _hoisted_53 = ["src", "alt"]
const _hoisted_54 = { class: "font-bold" }
const _hoisted_55 = { class: "flex flex-col bg-primary-black px-8 py-20 gap-5 mb-24" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-black text-white" }, "See what Workbean can do for your employer branding journey today.", -1))
const _hoisted_57 = { href: "https://share.hsforms.com/16L5jPV9wTKm7A5nG7cF_tA49jl2" }

import Menubar from "@/components/menuBar.vue"
  import { useMetadataStore } from "@/store/metadata"
  import { onMounted } from "vue"
  // image
  import HeaderImage from "@/assets/images/solutions/image/headline-banner.svg"
  import CultureBanner from "@/assets/images/solutions/image/culture-banner.svg"
  import AmbassadorBanner from "@/assets/images/solutions/image/ambassador-banner.svg"
  import DeepDive from "@/assets/images/solutions/image/deep_dive_banner.svg"
  import EBBanner from "@/assets/images/solutions/image/eb-banner.svg"
  import CertificationSeal from "@/assets/images/solutions/image/certification-seal.svg"
  import SinglifeTestimonial from "@/assets/images/solutions/image/singlife.svg"
  import AtlassianTestimonial from "@/assets/images/solutions/image/atlassian.svg"

  // company logo
  import Atlassian from "@/assets/images/solutions/logos/atlassian.svg"
  import Inpiro from "@/assets/images/solutions/logos/inspiro.svg"
  import Kumu from "@/assets/images/solutions/logos/kumu.svg"
  import Lalamove from "@/assets/images/solutions/logos/lalamove.svg"
  import Omni from "@/assets/images/solutions/logos/omni.svg"
  import Singlife from "@/assets/images/solutions/logos/singlife.svg"
  import Tala from "@/assets/images/solutions/logos/tala.svg"
  import Abscbn from "@/assets/images/solutions/logos/abscbn.webp"
  import AdoboMagazine from "@/assets/images/solutions/logos/adobomagazine.webp"
  import Anc from "@/assets/images/solutions/logos/anc.webp"
  import E27 from "@/assets/images/solutions/logos/e27.webp"
  import Hrdigital from "@/assets/images/solutions/logos/hrdigital.webp"
  import Philstar from "@/assets/images/solutions/logos/philstar.webp"
  import Sparkup from "@/assets/images/solutions/logos/sparkup.webp"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SolutionsPage',
  setup(__props) {

  const companiesData = [
    { name: "Lalamove", logo: Lalamove, link: "https://www.workbean.co/company/lalamove" },
    { name: "Omni", logo: Omni, link: "https://www.workbean.co/company/omni_channel_solutions" },
    { name: "Tala", logo: Tala, link: "https://www.workbean.co/company/tala_financing_philippines_inc" },
    { name: "Kumu", logo: Kumu, link: "https://www.workbean.co/company/kumu" },
    { name: "Singlife", logo: Singlife, link: "https://www.workbean.co/company/singlifetech" },
    { name: "Atlassian", logo: Atlassian, link: "https://www.workbean.co/company/atlassian" },
    { name: "Inpiro", logo: Inpiro, link: "#" },
  ]

  const mediaOutlets = [
    { name: "Abscbn", logo: Abscbn },
    { name: "AdoboMagazine", logo: AdoboMagazine },
    { name: "Anc", logo: Anc },
    { name: "E27", logo: E27 },
    { name: "Hrdigital", logo: Hrdigital },
    { name: "Philstar", logo: Philstar },
    { name: "Sparkup", logo: Sparkup },
  ]

  const testimonialsData = [
    {
      company: "Singlife",
      image: SinglifeTestimonial,
      logo: Singlife,
      testimonial:
        "Workbean’s Worksona Quiz helped us humanize our interactions with each team member. The Workbean Employer Brand Survey also helped us understand our group archetype at a deeper level. From a leadership standpoint, we know where to focus more. This also saved us from going through group therapy this year.",
    },
    {
      company: "Atlassian",
      image: AtlassianTestimonial,
      logo: Atlassian,
      testimonial: "Workbean has been helpful to us and our job seekers in drumbeating what Atlassian is about and highlighting our corporate values, which we believe is unique as it is universal.",
    },
  ]

  const metadataStore = useMetadataStore()

  onMounted(() => {
    metadataStore.details.title = "Employer Branding Consulting Company | Workbean"
    metadataStore.details.description = "Let's help you establish what makes your company unique by enhancing your employer branding strategies with Workbean's employer branding consultancy services."
    metadataStore.details.og.title = "Employer Branding Consulting Company | Workbean"
    metadataStore.details.og.description =
      "Let's help you establish what makes your company unique by enhancing your employer branding strategies with Workbean's employer branding consultancy services."
    metadataStore.details.twitter.title = "Employer Branding Consulting Company | Workbean"
    metadataStore.details.twitter.description =
      "Let's help you establish what makes your company unique by enhancing your employer branding strategies with Workbean's employer branding consultancy services."
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_slide = _resolveComponent("ion-slide")!
  const _component_ion_slides = _resolveComponent("ion-slides")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(Menubar),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _unref(HeaderImage),
                  alt: "Workbean Solutions",
                  class: "w-full object-top object-cover h-full"
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _createElementVNode("a", _hoisted_8, [
                  _createVNode(_component_ion_button, {
                    type: "primary",
                    class: "text-white font-bold h-[45px]"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ask us how")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("ul", _hoisted_11, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(companiesData, (companies) => {
                  return _createElementVNode("li", {
                    key: `${companies}_id`,
                    class: "grayscale hover:grayscale-0 cursor-pointer flex-shrink-0"
                  }, [
                    _createElementVNode("a", {
                      href: companies.link
                    }, [
                      _createElementVNode("img", {
                        class: "object-center h-[35px]",
                        src: companies.logo,
                        alt: companies.name
                      }, null, 8, _hoisted_13)
                    ], 8, _hoisted_12)
                  ])
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("img", {
                  src: _unref(CultureBanner),
                  alt: "Culture Banner",
                  class: "w-full object-top object-cover h-full"
                }, null, 8, _hoisted_17)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _hoisted_20,
                _createElementVNode("a", _hoisted_21, [
                  _createVNode(_component_ion_button, {
                    type: "primary",
                    class: "text-white font-bold h-[45px]"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ask us how")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("img", {
                    src: _unref(AmbassadorBanner),
                    alt: "Ambassadorship Banner",
                    class: "w-full object-top object-cover h-full"
                  }, null, 8, _hoisted_24)
                ])
              ]),
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("img", {
                    src: _unref(EBBanner),
                    alt: "Employer Brand Banner",
                    class: "w-full object-top object-cover h-full"
                  }, null, 8, _hoisted_28)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("a", _hoisted_30, [
                  _createVNode(_component_ion_button, {
                    type: "primary",
                    class: "text-white font-bold h-[60px] text-[22px]"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ask us how")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("img", {
                    src: _unref(DeepDive),
                    alt: "Deep Dive Banner",
                    class: "w-full object-top object-cover h-full"
                  }, null, 8, _hoisted_36)
                ])
              ]),
              _createElementVNode("a", _hoisted_37, [
                _createVNode(_component_ion_button, {
                  type: "primary",
                  class: "text-white font-bold h-[60px] text-[22px]"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Explore with us")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("img", {
                    src: _unref(CertificationSeal),
                    alt: "Certified Employer Banner",
                    class: "w-full object-top object-cover h-full"
                  }, null, 8, _hoisted_43)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("ul", _hoisted_46, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(mediaOutlets, (media) => {
                  return _createElementVNode("li", {
                    key: `${media}_id`,
                    class: "grayscale hover:grayscale-0 cursor-pointer px-4 flex-shrink-0"
                  }, [
                    _createElementVNode("img", {
                      class: "object-center h-[35px]",
                      src: media.logo,
                      alt: media.name
                    }, null, 8, _hoisted_47)
                  ])
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _createVNode(_component_ion_slides, null, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(testimonialsData, (testimonials) => {
                    return _createVNode(_component_ion_slide, {
                      key: `${testimonials}_id`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("img", {
                              src: testimonials.image,
                              alt: testimonials.company
                            }, null, 8, _hoisted_52),
                            _createElementVNode("img", {
                              src: testimonials.logo,
                              alt: testimonials.company,
                              class: "px-14 pt-5"
                            }, null, 8, _hoisted_53)
                          ]),
                          _createElementVNode("p", _hoisted_54, "\"" + _toDisplayString(testimonials.testimonial) + "\"", 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  }), 64))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _createElementVNode("a", _hoisted_57, [
                _createVNode(_component_ion_button, {
                  style: `--ion-color-primary: #E14D83`,
                  class: "text-[22px] h-[60px] w-fit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Schedule a chat")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})